import { otherOptionValue } from '..';

type IFormData = {
  selectedOption: string;
  otherText: string;
  error: string;
};

export const isFormValid = (formData: IFormData): boolean => {
  const onlyNumbers = /^[^a-zA-Z]+$/.test(formData.otherText);
  const isOptionSelected = !!formData.selectedOption;
  const isOtherOptionSelected = formData.selectedOption === otherOptionValue;

  if (!isOptionSelected) {
    return false;
  }

  if (isOtherOptionSelected) {
    if (formData.otherText) {
      if (onlyNumbers) {
        throw new Error('Must not be purely numeric');
      }

      if (formData.otherText.length < 6) {
        throw new Error('Must be at least 6 characters');
      }

      if (formData.otherText.length > 251) {
        throw new Error('Must be at most 251 characters');
      }
    } else {
      return false;
    }
  }

  formData.error = '';
  return true;
};
